import React from 'react';
import styled from 'styled-components';
import { Box, Typography, Link } from '@material-ui/core';

const Kontakt = () => (
  <ContentContainer>
    <Box marginTop="37px">
      <Typography variant="h2">Kontakt</Typography>
    </Box>
    <Box margin="28px 0">
      <Typography variant="subtitle1">
        Har du spørgsmål, eller har brug for yderligere oplysninger om Min
        Energiberegner, er du altid velkommen til at kontakte os på:{' '}
        <Link href="mailto:info@mailreal.dk" target="_blank" rel="noopener">
          info@mailreal.dk
        </Link>{' '}
        eller{' '}
        <Link href="mailto:info.dk-BLS@tuvsud.com" target="_blank" rel="noopener">
          info.dk-BLS@tuvsud.com
        </Link>
      </Typography>
    </Box>
  </ContentContainer>
);

const ContentContainer = styled.div`
  width: 100%;
  box-sizing: border-box;
`;

export default Kontakt;
